import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { parseAdminEmailSearch } from "./admin-email-search";
import { EmailTemplateManager } from "@/features/admin/components/email-template-manager";
import { PageContainer } from "@fleet/ui";

function AdminEmailPage() {
  return (
    <PageContainer maxWidth="6xl">
      <EmailTemplateManager />
    </PageContainer>
  );
}

/** URL-addressable email template editor (#15b G8). */
export const adminEmailRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email",
  validateSearch: parseAdminEmailSearch,
  component: AdminEmailPage,
});
